import { action } from 'action/index';
import axios from 'axios';

export const downloadFile = async (id: string, resourceId: string, fileName: string, preview = false) => {
  const pathname = window.location.pathname;
  // 支持中心及新闻
  const isSupportCenter = ['tutorial', 'faq', 'news'].some(str => {
    return pathname.indexOf(str) > -1;
  });
  let res;
  if (isSupportCenter) {
    res = await action.getResourceForSupportCenter(resourceId);
  } else {
    res = await action.getResource(id, resourceId);
  }

  if (res) {
    if (preview) {
      return res;
    }
    const data = await axios.get(res, {
      responseType: 'arraybuffer',
    });
    const blob = new Blob([data.data]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
};
